import { CheckedAddress } from '@sparkdotfi/common-universal'

import { ActionConfig, ActionContext } from '../../../logic/types'
import { ClaimAirdropRewardsAction } from '../types'
import {
  cookie3AirdropRewardsAddress,
  ignitionAirdropRewardsAddress,
  socialAndPreFarmingAirdropRewardsAddress,
} from '@/config/abis/addresses'
import { sparkRewardsConfig } from '@/config/contracts-generated'
import { getContractAddress } from '@/domain/hooks/useContractAddress'
import { getBalancesQueryKeyPrefix } from '@/domain/wallet/getBalancesQueryKeyPrefix'
import { ensureConfigTypes } from '@/features/actions/logic/transactions/useWrite'
import { airdropClaimsQueryKey } from '@/features/spk/airdrop/logic/airdropClaimsQuery'

export function createClaimAirdropRewardsActionConfig(
  action: ClaimAirdropRewardsAction,
  context: ActionContext,
): ActionConfig {
  const { account, chainId } = context
  const rewardsContractAddress = getContractAddress(getRewardsContractAddress(action.source), chainId)
  const rewardsContractAbi = sparkRewardsConfig.abi // should be the same for all rewards cotnracts

  const { epoch, token, cumulativeAmount, merkleRoot, merkleProof } = action

  return {
    getWriteConfig: () => {
      return ensureConfigTypes({
        address: rewardsContractAddress,
        abi: rewardsContractAbi,
        functionName: 'claim',
        args: [BigInt(epoch), account, token.address, token.toBigInt(cumulativeAmount), merkleRoot, merkleProof],
      })
    },

    invalidates: () => [
      getBalancesQueryKeyPrefix({ chainId, account }),
      airdropClaimsQueryKey({ address: CheckedAddress(account), chainId }),
    ],
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function getRewardsContractAddress(source: ClaimAirdropRewardsAction['source']) {
  switch (source) {
    case 'spk-ignition-airdrop':
      return ignitionAirdropRewardsAddress
    case 'spk-social-and-prefarming-airdrop':
      return socialAndPreFarmingAirdropRewardsAddress
    case 'spk-cookie3-airdrop':
      return cookie3AirdropRewardsAddress
  }
}
